<template>
  <section class="foot-content-container">
    <div class="foot-content-div">
      <div class="logo-container pic-full"></div>
      <div class="url-container">
        <a
          v-for="item in homeLang.foot.info"
          :href="item.url"
          target="_blank"
          >{{ item.title }}</a
        >
        <div class="switch-lang flex-center" @click="switchLang()">
          {{ homeLang.foot.language }}
        </div>
      </div>
      <div class="media-container">
        <a class="tg-container" @click="goTelegram" href="javascript:;">
          <div
            class="icon-container pic-full"
            :title="homeLang.foot.media.tgUrl"
          ></div>
        </a>
        <a
          class="mail-container"
          :href="'mailTo:' + homeLang.foot.media.mailUrl"
        >
          <div
            class="icon-container pic-full"
            :title="homeLang.foot.media.mailUrl"
          ></div>
        </a>
        <a
          class="code-cat-container"
          :href="homeLang.foot.media.codeCatUrl"
          target="_blank"
        >
          <div
            class="icon-container pic-full"
            :title="homeLang.foot.media.codeCatUrl"
          ></div>
        </a>
        <a
          class="twitter-container"
          :href="homeLang.foot.media.twitterUrl"
          target="_blank"
        >
          <div
            class="icon-container pic-full"
            :title="homeLang.foot.media.twitterUrl"
          ></div>
        </a>
        <a class="m-container" :href="homeLang.foot.media.mUrl" target="_blank">
          <div
            class="icon-container pic-full"
            :title="homeLang.foot.media.mUrl"
          ></div>
        </a>
      </div>
    </div>
    <p class="copyright">{{ homeLang.foot.copyright }}</p>
    <Modal v-if="show" @close="close" :homeLang="homeLang" />
  </section>
</template>

<script>
import Modal from '../tools/Modal.vue'
export default {
  name: 'FootContent',
  data() {
    return {
      show: false,
    }
  },
  components: { Modal },
  props: {
    homeLang: {
      type: Object,
    },
  },
  methods: {
    goTelegram() {
      this.show = true
      // window.open(this.homeLang.foot.media.tgUrl)
    },
    close() {
      this.show = false
    },
  },
}
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .foot-content-container {
    .foot-content-div {
      height: 0.91rem;
      width: 10rem;
      margin-left: 0.63rem;
      border-bottom: #d8d8d8 1px solid;
      .url-container {
        float: left;
        position: relative;
        width: 7rem;
        margin-top: 0.35rem;
        a {
          font-size: 0.16rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #333333;
          line-height: 0.22rem;
          margin-right: 0.5rem;
          float: left;
          cursor: pointer;
          &:hover {
            color: #2761e7;
          }
        }
        .switch-lang {
          right: -2.34rem;
          top: 0.72rem;
          position: absolute;
          cursor: pointer;
          float: right;
          width: 1.08rem;
          height: 0.35rem;
          border: 1px solid #999999;
          border-radius: 0.2rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #333333;
        }
      }
      .media-container {
        float: right;
        width: 3rem;
        height: 0.36rem;
        margin-top: 0.28rem;
        > a {
          margin-right: 0.3rem;
          float: left;
          .icon-container {
            width: 0.36rem;
            height: 0.36rem;
            cursor: pointer;
          }
        }
        .tg-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/tg.png');
            &:hover {
              background-image: url('../../assets/pc/footer/tg_active.png');
            }
          }
        }
        .mail-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/mail.png');
            &:hover {
              background-image: url('../../assets/pc/footer/mail_active.png');
            }
          }
        }
        .code-cat-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/codeCat.png');
            &:hover {
              background-image: url('../../assets/pc/footer/codeCat_active.png');
            }
          }
        }
        .twitter-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/twitter.png');
            &:hover {
              background-image: url('../../assets/pc/footer/twitter_active.png');
            }
          }
        }
        .m-container {
          margin-right: 0;
          .icon-container {
            background-image: url('../../assets/pc/footer/m.png');
            &:hover {
              background-image: url('../../assets/pc/footer/m_active.png');
            }
          }
        }
      }
    }
    .copyright {
      width: 5.92rem;
      font-size: 0.14rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #999999;
      line-height: 0.2rem;
      margin-bottom: 1rem;
      margin-left: 0.63rem;
      margin-top: 0.18rem;
    }
  }
}

@media screen and (max-width: 767px) {
  .foot-content-container {
    .foot-content-div {
      height: 2.28rem;
      width: 7.1rem;
      margin-left: 0.23rem;
      border-bottom: #d8d8d8 0.5px solid;
      position: relative;
      .logo-container {
        position: absolute;
        left: 0;
        top: 0.37rem;
        width: 1.23rem;
        height: 0.44rem;
        background-image: url('../../assets/mobile/xswap.png');
      }
      .url-container {
        float: right;
        width: 2.33rem;
        height: 100%;
        a,
        .switch-lang {
          display: block;
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #333333;
          line-height: 0.33rem;
          margin-top: 0.28rem;
          &:first-child {
            margin-top: 0.49rem;
          }
        }
      }
      .media-container {
        float: left;
        width: 3.87rem;
        height: 0.44rem;
        margin-top: 1.08rem;
        > a {
          margin-right: 0.37rem;
          float: left;
          .icon-container {
            width: 0.44rem;
            height: 0.44rem;
          }
        }
        .tg-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/tg.png');
          }
        }
        .mail-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/mail.png');
          }
        }
        .code-cat-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/codeCat.png');
          }
        }
        .twitter-container {
          .icon-container {
            background-image: url('../../assets/pc/footer/twitter.png');
          }
        }
        .m-container {
          margin-right: 0;
          .icon-container {
            background-image: url('../../assets/pc/footer/m.png');
          }
        }
      }
    }
    .copyright {
      font-size: 0.21rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #999999;
      line-height: 0.3rem;
      margin-bottom: 0.15rem;
      margin-left: 0.23rem;
      margin-top: 0.18rem;
      transform: scale(0.66);
      transform-origin: 0 0;
      text-align: left;
    }
  }
}
</style>